import { NgModule } from '@angular/core';
import { CommonModule as AngularCommon } from '@angular/common';

import { PipesModule } from '../../pipes/pipes.module';

import { StepTrackerComponent } from './step-tracker.component';

@NgModule({
  imports: [
    AngularCommon,
    PipesModule,
    StepTrackerComponent
  ],
  exports: [
    StepTrackerComponent
  ]
})
export class StepTrackerModule {
}
